import { render, staticRenderFns } from "./ProductSafetyDetail.vue?vue&type=template&id=b2838be6&scoped=true"
import script from "./ProductSafetyDetail.vue?vue&type=script&lang=js"
export * from "./ProductSafetyDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductSafetyDetail.vue?vue&type=style&index=0&id=b2838be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2838be6",
  null
  
)

export default component.exports